import { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getAllTechnicians } from '../../api/technicians';

const Technicians = () => {
  const [loading, setLoading] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const history = useHistory();

  const getData = useCallback(async () => {
    setLoading(true);
    const technicians = await getAllTechnicians();
    setTechnicians(technicians);
    setLoading(false);
  }, []);

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [getData]);

  if (loading)
    return (
      <main className="th-main">
        <section className="th-canvas" />
      </main>
    );

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header members-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <Link to="/technicians" className="active">
              Technicians
            </Link>
          </h2>

          <section className="view-actions">
            <button
              className="btn-green"
              data-cy="submit"
              onClick={() => history.push('/technicians/add')}
            >
              Add technician
            </button>
          </section>
        </header>

        <section className="view-container">
          <section className="content-list">
            <ol className="members-list th-list">
              <li className="th-list-row header">
                <div className="th-filter-header" id="th-filter-header">
                  <div className="th-filter-header-label">Name</div>
                </div>
                <div className="th-select-header nowrap">
                  <div className="th-select-header-label">City</div>
                </div>
                <div className="th-select-header nowrap">
                  <div className="th-select-header-label">Address</div>
                </div>
              </li>
              {technicians.map((d) => (
                <li
                  key={d.id}
                  className="th-list-row th-members-list-item pointer"
                  onClick={() => history.push(`/technicians/${d.id}`)}
                >
                  <div className="th-list-data th-members-list-basic">
                    <div className="flex items-center">
                      <figure className="th-member-gravatar w9 h9 mr3 flex-shrink-0">
                        <img
                          className="th-member-avatar-image"
                          src={d.avatarUrl || '/images/ghost.svg'}
                          alt="avatar"
                        />
                      </figure>
                      <div>
                        <h3 className="ma0 pa0 th-members-list-name ">
                          {d.firstName} {d.lastName}
                        </h3>
                        <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                          <span>{d.email}</span>
                        </p>
                        <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                          <span>{d.phone}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="th-list-data middarkgrey f8">
                    <span className="midlightgrey">{d.city}</span>
                  </div>
                  <div className="th-list-data middarkgrey f8">
                    <span className="midlightgrey">{d.address}</span>
                  </div>
                </li>
              ))}
            </ol>
          </section>
        </section>
      </section>
    </main>
  );
};

export default Technicians;
